<!-- @veltra/icons generated sha256:90df099f6bf6ba91 gen:8 source:src/svg/normal/form-number-input.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormNumberInput' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="m4.2 7.2.8-.7V10m3-3c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1c0 .5-.3.9-.6 1.2L8 10h3"
    />
  </svg>
</template>
